const CallIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9827 2.742C29.9247 3.53327 32.6071 5.08366 34.7614 7.2379C36.9156 9.39214 38.466 12.0746 39.2573 15.0166"
        stroke="#FB2576"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.1868 9.44998C26.9516 9.92477 28.5607 10.8549 29.853 12.1472C31.1453 13.4394 32.0754 15.0485 32.5502 16.8134"
        stroke="#FB2576"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4625 21.1413C14.2621 24.8218 17.2449 27.7917 20.933 29.5755C21.2031 29.7034 21.5018 29.7587 21.7998 29.7359C22.0977 29.713 22.3846 29.6129 22.632 29.4453L28.0639 25.8252C28.3038 25.665 28.5799 25.5672 28.8671 25.5405C29.1544 25.5139 29.4437 25.5592 29.709 25.6725L39.8699 30.0284C40.215 30.175 40.5032 30.4298 40.691 30.7544C40.8788 31.079 40.9561 31.4558 40.9112 31.828C40.5895 34.3409 39.3631 36.6504 37.4616 38.3242C35.56 39.998 33.1135 40.9214 30.5802 40.9216C22.7558 40.9216 15.2518 37.8134 9.71909 32.2807C4.18637 26.748 1.07813 19.244 1.07812 11.4195C1.07836 8.8864 2.00185 6.4402 3.67571 4.5389C5.34957 2.6376 7.65903 1.41156 10.1717 1.09033C10.544 1.04543 10.9208 1.1227 11.2454 1.31049C11.5699 1.49829 11.8247 1.78645 11.9713 2.13158L16.3307 12.3011C16.4428 12.5639 16.4883 12.8503 16.4632 13.1348C16.4381 13.4194 16.3431 13.6934 16.1867 13.9324L12.577 19.4476C12.4132 19.6959 12.3165 19.9825 12.2964 20.2794C12.2764 20.5762 12.3336 20.8732 12.4625 21.1413V21.1413Z"
        stroke="#FB2576"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CallIcon;
